import { render, staticRenderFns } from "./ExtActExpressionModal.vue?vue&type=template&id=2d8953ac&scoped=true&"
import script from "./ExtActExpressionModal.vue?vue&type=script&lang=js&"
export * from "./ExtActExpressionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8953ac",
  null
  
)

export default component.exports